import { GetterTree } from 'vuex';

import { PatientStateI } from './state';
import { RootStateI } from '../state';

const getters: GetterTree<PatientStateI, RootStateI> = {
  // user(state: PatientStateI) {
  //   return state.user;
  // },
};

export default getters;
